export default {
  data() {
    return {
      entity_name: sessionStorage.getItem('entity_name'), 
      showAlert: true,
      metrics: [
  {
    label: 'Total Beneficiaries',
    value: '156',
    subtext: '12 pending verification',
    icon: 'fas fa-user',
    iconBg: 'bg-success-subtle text-success',
    trend: '8%'
  },
  {
    label: 'Active Trustees',
    value: '5',
    subtext: 'All verified',
    icon: 'fas fa-shield-alt',
    iconBg: 'bg-warning-subtle text-warning'
  },
  {
    label: 'Trust Documents',
    value: '47',
    subtext: '3 require updates',
    icon: 'fas fa-file-alt',
    iconBg: 'bg-secondary-subtle text-secondary'
  },
  {
    label: 'YTD Distributions',
    value: 'R7.05M',
    subtext: 'Across 3 payments',
    icon: 'fas fa-wallet',
    iconBg: 'bg-success-subtle text-success',
    trend: '12.5%'
  }
      ],
      recentDocuments: [
        { name: 'Trust Deed - Amended 2024', category: 'Legal', date: '15 Jan 2024', typeClass: 'red-doc' },
        { name: 'Annual Financial Statement', category: 'Financial', date: '28 Feb 2024', typeClass: 'green-doc' }
      ],
      heatmapData: [
        { label: 'KYC Verification', value: 78, colorClass: 'bg-warning-subtle text-warning' },
        { label: 'Document Currency', value: 95, colorClass: 'bg-success-subtle text-success' },
        { label: 'Meeting Attendance', value: 92, colorClass: 'bg-success-subtle text-success' },
        { label: 'Banking Details', value: 88, colorClass: 'bg-success-subtle text-success' }
      ],
    meetings: [
        { id: 1, type: 'Trustee Meeting', title: 'Q1 Trustee Review Meeting', date: '28 Jan 2025', time: '10:00 AM', badgeClass: 'bg-secondary-subtle text-secondary' },
        { id: 2, type: 'Annual General Meeting', title: 'Annual General Meeting', date: '15 Feb 2025', time: '10:00 AM', badgeClass: 'bg-success-subtle text-success' },
        { id: 3, type: 'Special Meeting', title: 'Special Resolution - Amendment', date: '22 Feb 2025', time: '10:00 AM', badgeClass: 'bg-warning-subtle text-warning' }
    ]

    };
  },
  methods: {
    viewCalendar() {
        // logic to view calendar
    }
  }
};